import React from 'react';
// import { log } from '#emyw/core-lib';

const CornerLabel = props => {
  const {
    className,
    style
  } = props;
  if (!style.color) style.color = '#008f09';
  const random = Math.floor(Math.random() * 10000);
  // log.trace('props:', props);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 1120",
    style: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient".concat(random),
    cx: "515.28815",
    cy: "496.98511",
    fx: "515.28815",
    fy: "496.98511",
    r: "500",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.3311248,1.3023699,-1.7898389,1.8293567,769.76837,-966.45758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    style: {
      stopColor: 'currentColor',
      stopOpacity: '0.3'
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    style: {
      stopColor: 'currentColor',
      stopOpacity: '1'
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient".concat(random),
    x1: "508.92856",
    y1: "491.07144",
    x2: "571.42859",
    y2: "428.57144",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    style: {
      stopColor: 'black',
      stopOpacity: '0'
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    style: {
      stopColor: 'black',
      stopOpacity: '1'
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1120,0 1120,1120",
    style: {
      fill: "url(#linearGradient".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1000,1000 0,0 1000,0 ",
    style: {
      fill: 'white'
    },
    transform: "translate(120)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1000,0 1000,1000",
    style: {
      fill: "url(#radialGradient".concat(random, ")")
    },
    transform: "translate(120)"
  })));
};
CornerLabel.defaultProps = {
  className: null,
  style: {}
};
export default CornerLabel;